// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"0c0fca49","421":"bf35ec56"}[chunkId] + ".chunk.css";
};